
// src/reducers/activity-report-reducer.js

import { 
  FETCH_ACTIVITY_REPORTS,
  FETCH_ACTIVITY_REPORTS_REQUESTED,
  FETCH_ACTIVITY_REPORTS_COMPLETED,
  FETCH_ACTIVITY_REPORTS_FAILED,
  FETCH_MONTHLY_ACTIVITY_REPORT,
  FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED,
  FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED,
  FETCH_MONTHLY_ACTIVITY_REPORT_FAILED,
  CLEAR_ACTIVITY_REPORTS,
  CLEAR_MONTHLY_ACTIVITY_REPORTS,
} from '../actions/activity-report'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  isMonthlyFetching: false,
  isMonthlyFetchFailed: false
}

export default function activityReportReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_ACTIVITY_REPORTS_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
    })

  case FETCH_ACTIVITY_REPORTS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: action.results,
    })

    case FETCH_ACTIVITY_REPORTS_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

    case CLEAR_ACTIVITY_REPORTS:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: undefined
    })

    case FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED:
    return Object.assign({}, state, {
      isMonthlyFetching: true,
      isMonthlyFetchFailed: false,
    })

  case FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED:
    return Object.assign({}, state, {
      isMonthlyFetching: false,
      isMonthlyFetchFailed: false,
      monthly_item: action.results,
    })

  case FETCH_MONTHLY_ACTIVITY_REPORT_FAILED:
    return Object.assign({}, state, {
      isMonthlyFetching: false,
      isMonthlyFetchFailed: true,
    })

  case CLEAR_MONTHLY_ACTIVITY_REPORTS:
    return Object.assign({}, state, {
      isMonthlyFetching: false,
      isMonthlyFetchFailed: false,
      monthly_item: undefined
    })

  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/activity-report-reducer.js